export default function ShopWindowHints() {
  return (
    <div className="shop-window-hints content-alt-1 tw:absolute tw:flex tw:h-full tw:w-full tw:flex-col tw:items-stretch tw:justify-center">
      <div className="shop-window-hints-description tw:text-center tw:[margin:0_30px_0_30px]">
        <p className="hint-title highlight-fg-1 tw:[.landscape_&]:font-bold tw:[.landscape_&]:text-[26px] tw:[.portrait_&]:font-[600] tw:[.portrait_&]:text-[18px]"></p>
        <p className="hint-subtitle tw:[.landscape_&]:text-[14px] tw:[.portrait_&]:text-[14px]"></p>
      </div>
    </div>
  );
}
